/** Set a cookie to expire in given days
 * @param   {string}    cname cookie name
 * @param   {string}    cvalue cookie value
 * @param   {number}    exdays expiration in days
 * @returns {Object} undefined
 */
export function setCookie(cname, cvalue, exdays) {
  const d = new Date();

  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;

  document.cookie = `${cname}=${cvalue};${expires};path=/`;
}

/** Get a named cookie from the document cookie jar
 * @param   {string}    cname cookie name
 * @returns {Object} undefined
 */
export function getCookie(cname) {
  if (typeof document === 'undefined') {
    return;
  }

  const name = `${cname}=`;
  const ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];

    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

/** Get a named cookie subvalue from the given ASP Cookie
 * @param   {string}  cookie  the Legacy Global cookie
 * @param   {string}  segmentName the part of the cookie we are seeking
 * @returns {string} the value of the requested segment of the Global cookie
 */
export function getAspCookieSubValue(cookie, segmentName) {
  if (cookie) {
    const segments = cookie.split('&').map(segment => segment.trim());
    const segmentKey = `${segmentName}=`;
    let affiliateIdSegment = segments.find(segment =>
      segment.startsWith(segmentKey)
    );

    if (affiliateIdSegment) {
      if (affiliateIdSegment.endsWith('|')) {
        affiliateIdSegment = affiliateIdSegment.slice(0, -1);
      }
      return affiliateIdSegment.slice(segmentKey.length);
    }
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/reactModules/shared/utilities/cookies.js